function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M179.5 21.5s-121-6-152 36 39 42 144 45 225.08-33.55 138-72c-77-34-162-9-162-9",
  fill: "none",
  stroke: "#ff0",
  strokeWidth: 9,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

function SvgMenuRolloverWorks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu-rollover-works_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 356 113",
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzNTYgMTEzIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAzNTYgMTEzOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6bm9uZTtzdHJva2U6I0ZGRkYwMDtzdHJva2Utd2lkdGg6OTtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cgkuc3Qxe2ZpbGw6bm9uZTtzdHJva2U6I0ZGRkYwMDtzdHJva2Utd2lkdGg6OTtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQo8L3N0eWxlPgo8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMTc5LjUsMjEuNWMwLDAtMTIxLTYtMTUyLDM2czM5LDQyLDE0NCw0NXMyMjUuMDgtMzMuNTUsMTM4LTcyYy03Ny0zNC0xNjItOS0xNjItOSIvPgo8L3N2Zz4K";
export { SvgMenuRolloverWorks as ReactComponent };